// extracted by mini-css-extract-plugin
export default {"imageWrapper":"MG-z","videoWrapper":"NG-z","twoColumnImage":"OG-z","imageCarouselBtn":"PG-z","carouselNextBtn":"QG-z","carouselPrevBtn":"RG-z"};